import Axios from "axios";
import {Config} from "../config";

const AxiosInstance = Axios.create({
    baseURL: Config.HTTP_API_URI + '/',
    timeout: 10000
});

export default AxiosInstance;
